<template>
	<audio class="audio-payer" controls :src="src" />
</template>

<script>
export default {
	name: 'MessageAudio',
	props: {
		src: {
			type: String,
			default: ''
		}
	}
};
</script>
<style lang="scss" scoped>
.audio-payer {
	max-width: 268px;
}
</style>
